define('TescoMobile_Reevoo/js/model/bundle-skuswitch',['jquery', 'TescoMobile_Reevoo/js/model/reevoo'], function ($, reevoo) {
  'use strict';

  return function (widget) {
    $.widget('mage.productSummary', widget, {
      _renderOptionRow: function (key, optionIndex) {
        this._super(key, optionIndex);
        if (this.cache.currentElement.options[this.cache.currentKey].type.toUpperCase() == 'DEVICE') {
          var simpleSku = this.cache.currentElement.skus[this.cache.currentKey][optionIndex];
          reevoo.updateReevooReviews(simpleSku);
        }
      }
    });
    return $.mage.productSummary;
  };
});

